import { textWithHTML, percentage } from 'Data/format.js'

export function getText(credit_fee_percent, ach_fee_percent) {
  return textWithHTML(
    `A <b>platform fee of ${percentage(
      credit_fee_percent
    )}</b> will apply to all card payments and <b>${percentage(
      ach_fee_percent
    )}</b> to ACH payments. <b>Please note:</b> This fee may not be considered an eligible expense under a tax-advantaged account. Our system is designed to exclude this fee for Health Savings Account (HSA), Flexible Spending Account (FSA), Health Reimbursement Arrangement (HRA), and insurance reimbursement cards. However, some may not be excluded due to inconsistencies in how issuing banks categorize certain cards.`
  )
}
